import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import { LanguageProvider } from './context/LanguageContext';
import Header from './components/Header';
import Footer from './components/Footer';
import { FloatingContact } from './components/FloatingContact';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import TranslationManager from './pages/TranslationManager';
import Analytics from './pages/Analytics';
import Inquiries from './pages/Inquiries';
import { useVisitorTracker } from './hooks/useVisitorTracker';
import './App.css';

const TrackingWrapper = ({ children }) => {
  useVisitorTracker();
  return children;
};

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <TrackingWrapper>
              <div className="App min-h-screen bg-white dark:bg-black transition-colors duration-200">
                <Routes>
                  <Route path="/" element={<><Header /><Home /><Footer /><FloatingContact /></>} />
                  <Route path="/o-nas" element={<><Header /><About /><Footer /><FloatingContact /></>} />
                  <Route path="/sluzby" element={<><Header /><Services /><Footer /><FloatingContact /></>} />
                  <Route path="/realizace" element={<><Header /><Gallery /><Footer /><FloatingContact /></>} />
                  <Route path="/kontakt" element={<><Header /><Contact /><Footer /><FloatingContact /></>} />
                  
                  <Route path="/admin" element={<AdminLogin />} />
                  <Route 
                    path="/admin/dashboard" 
                    element={
                      <ProtectedRoute>
                        <AdminDashboard />
                      </ProtectedRoute>
                    } 
                  />
                  <Route 
                    path="/admin/translations" 
                    element={
                      <ProtectedRoute>
                        <TranslationManager />
                      </ProtectedRoute>
                    } 
                  />
                  <Route 
                    path="/admin/inquiries" 
                    element={
                      <ProtectedRoute>
                        <Inquiries />
                      </ProtectedRoute>
                    } 
                  />
                  <Route 
                    path="/admin/analytics" 
                    element={
                      <ProtectedRoute>
                        <Analytics />
                      </ProtectedRoute>
                    } 
                  />
                </Routes>
                <Toaster position="top-right" />
              </div>
            </TrackingWrapper>
          </BrowserRouter>
        </AuthProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
